module.exports = __webpack_public_path__ + "static/media/04_plantilla_combo_rectangular_marco_comida_11.90a15aa6.png";